import React, {useState, useEffect} from 'react'
import {getRemainingTimeFromMS} from '../utils/get-remaining-time-from-ms'
import {Link, createSearchParams} from 'react-router-dom'
import {Modal, ParagraphText} from '@thryvlabs/maverick'

const defaultRemainingTime = {
  days: '00',
  hours: '00',
  minutes: '10',
  seconds: '00',
}

function CountdownTimer({
  countdownTimeMS,
  linkId,
  type = '',
  isHourlyNeeded = false,
}) {
  const [remainingTime, setRemainingTime] = useState(defaultRemainingTime)

  useEffect(() => {
    const totalSeconds =
      Number(remainingTime.days || 0) * 86400 +
      Number(remainingTime.hours) * 3600 +
      Number(remainingTime.minutes) * 60 +
      Number(remainingTime.seconds)
    if (totalSeconds >= 1) {
      const intervalId = setInterval(() => {
        updateTime(countdownTimeMS)
      }, 1000)
      return () => clearTimeout(intervalId)
    } else {
      //will write something
    }
  }, [
    countdownTimeMS,
    remainingTime.days,
    remainingTime.hours,
    remainingTime.minutes,
    remainingTime.seconds,
  ])

  useEffect(() => {
    window.addEventListener('beforeunload', ev => {
      ev.preventDefault()
      return (ev.returnValue = 'Are you sure you want to close?')
    })
  }, [])

  function updateTime(countdown) {
    setRemainingTime(getRemainingTimeFromMS(countdown))
  }
  return (
    <>
      {type.length > 0 ? (
        Number(remainingTime.days || 0) * 86400 +
          Number(remainingTime.hours) * 3600 +
          Number(remainingTime.minutes) * 60 +
          Number(remainingTime.seconds) >
        0 ? (
          <>
            <ParagraphText
              variant={'reg'}
              color={'thryv-orange-500'}
              className={`font-weight-bold ${'mt-2'}`}
              style={{color: '#FF5000'}}
            >
              <span style={{color: '#FF5000'}}>Appointment(s) </span> Expire in:{' '}
              {isHourlyNeeded ? (
                <span style={{fontSize: '16px', color: '#FF5000'}}>
                  {remainingTime.days}:{remainingTime.hours}:
                  {remainingTime.minutes}:{remainingTime.seconds}
                </span>
              ) : (
                <span style={{fontSize: '16px', color: '#FF5000'}}>
                  {remainingTime.minutes}:{remainingTime.seconds}
                </span>
              )}
            </ParagraphText>
          </>
        ) : (
          <Modal
            title="Scheduled Appointments"
            variant="default"
            btnType="text"
            footer={false}
            hideX={true}
            disableBackdropClick={true}
            primaryFooterVariant="dark"
            width="700px"
            openOnLoad
            modalClassNames="custom-modal-style"
          >
            <ParagraphText color={'thryv-neutral'} variant="lg">
              Your appointments have expired. Please close this window and
              contact keap partner to generate new link.
            </ParagraphText>
          </Modal>
        )
      ) : (
        <ParagraphText
          variant={'reg'}
          className={`font-weight-bold`}
          style={{
            fontFamily: 'Open Sans',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '18px',
            verticalAlign: 'middle',
            marginBottom: '24px',
          }}
        >
          <span>Code valid for </span>
          <span style={{fontSize: '16px', color: '#FF5000'}}>
            {remainingTime.minutes}:{remainingTime.seconds}
          </span>{' '}
          <span> Haven&apos;t received it?</span>
          <Link
            to={{
              pathname: '/',
              search: createSearchParams({
                LinkId: linkId,
              }).toString(),
            }}
            style={{color: 'blue'}}
          >
            {' '}
            Retry again
          </Link>
        </ParagraphText>
      )}
    </>
  )
}

export default CountdownTimer
